import gql from "graphql-tag";
const createUserMutation = gql(`
mutation CreateUsers($input: CreateUsersInput!) {
  createUsers(input: $input) {
    cognitoId
    subId
    userid
		email
		phone
    subType
    credits
    tos
    conduct
    active
    renewal
    created
    lastUpdate
  }
}
`)
export default createUserMutation;
